<p-card class="p-card" header="Payments">
  <p-table
    stripedRows
    [value]="payments"
    responsiveLayout="scroll"
    selectionMode="single"
    [(selection)]="selectedPayment">
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">No payments found.</td>
      </tr>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Date</th>
        <th style="text-align: right">Amount</th>
        <th style="text-align: right">Amount Received</th>
        <th>Status</th>
        <th></th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData">
        <td>{{ rowData.payment_date * 1000 | date }}</td>
        <td style="text-align: right">{{ rowData.payment_total | currency : "USD" }}</td>
        <td style="text-align: right">{{ rowData.payment_received | currency : "USD" }}</td>
        <td>
          <span
            [ngClass]="
              rowData.payment_status === 'succeeded' ? 'green' : 'red'
            ">
            {{ rowData.payment_status }}
          </span>
        </td>
        <td style="text-align:right;">
          <p-button
            (click)="selectedPayment = rowData; menu.toggle($event)"
            icon="pi pi-ellipsis-v" />
        </td>
  </tr>
    </ng-template>
  </p-table>
  <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
</p-card>
